module.exports = "/_next/static/images/Frame-99bf2f6cd7adb35772702db0cae452e2.webp";